import React from 'react';
import Badge from '../Badge/Badge';
import Tooltip from '../Tooltip';

interface SensitiveStudentBadgeProps {
  visible?: boolean | null;
  reason?: string | null;
  className?: string;
}

const SensitiveStudentBadge: React.FC<SensitiveStudentBadgeProps> = ({
  visible,
  reason,
  className,
}) => {
  if (!visible) {
    return null;
  }

  return (
    <Tooltip content={reason}>
      <Badge variant="warning" solid className={className}>
        Sensível
      </Badge>
    </Tooltip>
  );
};

export default SensitiveStudentBadge;
